import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginPageComponent } from './modules/auth/login-page/login-page.component';
import { RegisterComponent } from './modules/auth/register/register.component';
import { CourseCombinationsPageComponent } from './modules/success-metrics/course-combinations/course-combinations-page/course-combinations-page.component';
import { PrerequisitesPageComponent } from './modules/success-metrics/prerequisite-impact/prerequisites-page/prerequisites-page.component';
import { CourseRecommenderPageComponent } from './modules/success-metrics/course-recommender/course-recommender-page/course-recommender-page.component';
import { StudentInfoPageComponent } from './modules/success-metrics/student-profile/student-info-page/student-info-page.component';
import { CohortInfoPageComponent } from './modules/success-metrics/cohort-profile/cohort-info-page/cohort-info-page.component';
import { CourseGradeEstimationPageComponent } from './modules/success-metrics/course-grade-estimation/course-grade-estimation-page/course-grade-estimation-page.component';
import { ProfilePageComponent } from './modules/users/user-profile/profile-page/profile-page.component';
import { UsersContentComponent } from './modules/users/users-content/users-content.';
import { onAuthGuard } from './core/guards/auth.guard';
import { AboutPageComponent } from './modules/about/about-page/about-page.component';
import { ProgramBottleneckPageComponent } from './modules/success-metrics/program-bottleneck-courses/program-bottleneck-page/program-bottleneck-page.component';
import { AtRiskStudentPageComponent } from './modules/success-metrics/at-risk-student/at-risk-student-page/at-risk-student-page.component';
import { CourseRankPageComponent } from './modules/success-metrics/course-rank/course-rank-page/course-rank-page.component';
import { PamlabLandingPageComponent } from './modules/marketing/pamlab-landing-page/pamlab-landing-page.component';
import { AprGraduationSummaryPageComponent } from './modules/admin-support/apr-graduation-summary/apr-graduation-summary-page/apr-graduation-summary-page.component';
import { EntryExitFlowPageComponent } from './modules/admin-support/entry-exit/entry-exit-flow-page/entry-exit-flow-page.component';
import { HelpHomepageComponent } from './modules/help/help-homepage/help-homepage.component';
import { ToolsSupportPageComponent } from './modules/help/tools-support-page/tools-support-page.component';
import { NavigateSupportPageComponent } from './modules/help/navigation-support-page/navigation-support-page.component';
import { GlossaryOfTermsPageComponent } from './modules/help/glossary-of-terms-page/glossary-of-terms-page.component';
import { AdvisorIdentifiedAtRiskHelpPageComponent } from './modules/success-metrics/at-risk-student/advisor-identified-at-risk-help-page/advisor-identified-at-risk-help-page.component';
import { CourseCombinationsHelpPageComponent } from './modules/success-metrics/course-combinations/course-combinations-help-page/course-combinations-help-page.component';
import { CourseRankHelpPageComponent } from './modules/success-metrics/course-rank/course-rank-help-page/course-rank-help-page.component';
import { PrerequisiteImpactHelpPageComponent } from './modules/success-metrics/prerequisite-impact/prerequisite-impact-help-page/prerequisite-impact-help-page.component';
import { ProgramBottleneckCoursesHelpPageComponent } from './modules/success-metrics/program-bottleneck-courses/program-bottleneck-courses-help-page/program-bottleneck-courses-help-page.component';
import { CourseRecommenderHelpPageComponent } from './modules/success-metrics/course-recommender/course-recommender-help-page/course-recommender-help-page.component';
import { CourseGradeEstimationHelpPageComponent } from './modules/success-metrics/course-grade-estimation/course-grade-estimation-help-page/course-grade-estimation-help-page.component';
import { AprGraduationSummaryHelpPageComponent } from './modules/admin-support/apr-graduation-summary/apr-graduation-summary-help-page/apr-graduation-summary-help-page.component';
import { NewApplicantsHelpPageComponent } from './modules/admin-support/new-applicants/new-applicants-help-page/new-applicants-help-page.component';
import { TransferEnrollmentTrendsExternalHelpPageComponent } from './modules/admin-support/transfer-enrollment-trends/transfer-enrollment-trends-external-help-page/transfer-enrollment-trends-external-help-page.component';
import { FticCourseDwfAprPageComponent } from './modules/admin-support/ftic-course-dwf-apr/ftic-course-dwf-apr-page/ftic-course-dwf-apr-page.component';
import { FticCourseDwfAprHelpPageComponent } from './modules/admin-support/ftic-course-dwf-apr/ftic-course-dwf-apr-help-page/ftic-course-dwf-apr-help-page.component';
import { CriticalCourseScoreHelpPageComponent } from './modules/admin-support/critical-course-score/critical-course-score-help-page/critical-course-score-help-page.component';
import { ThreeYearGraduationRateHelpPageComponent } from './modules/admin-support/three-year-graduation-rate/three-year-graduation-rate-help-page/three-year-graduation-rate-help-page.component';
import { FticCourseDwfAprExternalHelpPageComponent } from './modules/admin-support/ftic-course-dwf-apr/ftic-course-dwf-apr-external-help-page/ftic-course-dwf-apr-external-help-page.component';
import { AprGraduationSummaryExternalHelpPageComponent } from './modules/admin-support/apr-graduation-summary/apr-graduation-summary-external-help-page/apr-graduation-summary-external-help-page.component';
import { EntryExitFlowExternalHelpPageComponent } from './modules/admin-support/entry-exit/entry-exit-flow-external-help-page/entry-exit-flow-external-help-page.component';
import { CohortProfileHelpPageComponent } from './modules/success-metrics/cohort-profile/cohort-profile-help-page/cohort-profile-help-page.component';
import { StudentProfileHelpPageComponent } from './modules/success-metrics/student-profile/student-profile-help-page/student-profile-help-page.component';
import { EntryExitFlowHelpPageComponent } from './modules/admin-support/entry-exit/entry-exit-flow-help-page/entry-exit-flow-help-page.component';
import { AboutPamlabComponent } from './modules/home/about-pamlab/about-pamlab.component';
import { TransferEnrollmentTrendsPageComponent } from './modules/admin-support/transfer-enrollment-trends/transfer-enrollment-trends-page/transfer-enrollment-trends-page.component';
import { TransferEnrollmentTrendsHelpPageComponent } from './modules/admin-support/transfer-enrollment-trends/transfer-enrollment-trends-help-page/transfer-enrollment-trends-help-page.component';
import { InfoPageComponent } from './modules/info-main-page/info-page/info-page.component';
import { FeedbackPageComponent } from './modules/feedback/feedback-page/feedback-page.component';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  // { path: 'info', component: InfoPageComponent },
  { path: 'login', component: LoginPageComponent },
  { path: 'register', component: RegisterComponent },
  {
    path: 'users',
    component: UsersContentComponent,
    canActivate: [onAuthGuard('users')],
  },
  {
    path: 'landing-page',
    component: PamlabLandingPageComponent,
    canActivate: [onAuthGuard('general')],
  },
  {
    path: 'home',
    component: AboutPamlabComponent,
    canActivate: [onAuthGuard('general')],
  },
  {
    path: 'help-page',
    component: HelpHomepageComponent,
    canActivate: [onAuthGuard('general')],
  },
  {
    path: 'feedback',
    component: FeedbackPageComponent,
    canActivate: [onAuthGuard('general')],
  },

  // Tool cards routes
  {
    path: 'student-profile',
    component: StudentInfoPageComponent,
    canActivate: [onAuthGuard('student-profile')],
  },
  {
    path: 'cohort-profile',
    component: CohortInfoPageComponent,
    canActivate: [onAuthGuard('cohort-profile')],
  },
  {
    path: 'at-risk-students',
    component: AtRiskStudentPageComponent,
    canActivate: [onAuthGuard('at-risk-students')],
  },
  {
    path: 'course-combinations',
    component: CourseCombinationsPageComponent,
    canActivate: [onAuthGuard('course-combinations')],
  },
  {
    path: 'course-rank',
    component: CourseRankPageComponent,
    canActivate: [onAuthGuard('course-rank')],
  },
  {
    path: 'prerequisite-impact',
    component: PrerequisitesPageComponent,
    canActivate: [onAuthGuard('prerequisite-impact')],
  },
  {
    path: 'program-bottleneck-courses',
    component: ProgramBottleneckPageComponent,
    canActivate: [onAuthGuard('program-bottleneck-courses')],
  },
  {
    path: 'course-recommender',
    component: CourseRecommenderPageComponent,
    canActivate: [onAuthGuard('course-recommender')],
  },
  {
    path: 'course-grade-estimation',
    component: CourseGradeEstimationPageComponent,
    canActivate: [onAuthGuard('course-grade-estimation')],
  },
  {
    path: 'apr-graduation-summary',
    component: AprGraduationSummaryPageComponent,
    canActivate: [onAuthGuard('apr-graduation-summary')],
  },
  {
    path: 'entry-exit-flow',
    component: EntryExitFlowPageComponent,
    canActivate: [onAuthGuard('entry-exit-flow')],
  },
  {
    path: 'ftic-course-dwf-apr',
    component: FticCourseDwfAprPageComponent,
    canActivate: [onAuthGuard('ftic-course-dwf-apr')],
  },
  {
    path: 'transfer-enrollment-trends',
    component: TransferEnrollmentTrendsPageComponent,
    canActivate: [onAuthGuard('transfer-enrollment-trends')],
  },
  // {
  //   path: 'financial-aid-tools',
  //   canActivate: [onAuthGuard('financial-aid-tools')],
  //   component: RouterOutletPageComponent,
  //   children: [
  //     {
  //       path: 'financial-aid', // financial-aid-tool(child) route path
  //       component: FinancialAidToolPageComponent, // financial-aid-tool(child) route component that the router renders
  //       canActivate: [onAuthGuard('financial-aid-tools/financial-aid')],
  //     },
  //   ],
  // },
  // {
  //   path: 'help-pages',
  //   component: RouterOutletPageComponent,
  //   canActivate: [onAuthGuard('general')],
  //   children: [
  {
    path: 'tools-support',
    component: ToolsSupportPageComponent,
    canActivate: [onAuthGuard('general')],
  },
  {
    path: 'navigation-support',
    component: NavigateSupportPageComponent,
    canActivate: [onAuthGuard('general')],
  },
  {
    path: 'glossary-of-terms',
    component: GlossaryOfTermsPageComponent,
    canActivate: [onAuthGuard('general')],
  },
  //   ],
  // },
  // Success Metrics Tools Help Pages
  {
    path: 'student-profile-help-guide',
    component: StudentProfileHelpPageComponent,
    canActivate: [onAuthGuard('student-profile')],
  },
  {
    path: 'cohort-profile-help-guide',
    component: CohortProfileHelpPageComponent,
    canActivate: [onAuthGuard('cohort-profile')],
  },
  {
    path: 'at-risk-students-help-guide',
    component: AdvisorIdentifiedAtRiskHelpPageComponent,
    canActivate: [onAuthGuard('at-risk-students')],
  },

  {
    path: 'course-combinations-help-guide',
    component: CourseCombinationsHelpPageComponent,
    canActivate: [onAuthGuard('course-combinations')],
  },
  {
    path: 'course-rank-help-guide',
    component: CourseRankHelpPageComponent,
    canActivate: [onAuthGuard('course-rank')],
  },
  {
    path: 'prerequisite-impact-help-guide',
    component: PrerequisiteImpactHelpPageComponent,
    canActivate: [onAuthGuard('prerequisite-impact')],
  },
  {
    path: 'program-bottleneck-courses-help-guide',
    component: ProgramBottleneckCoursesHelpPageComponent,
    canActivate: [onAuthGuard('program-bottleneck-courses')],
  },
  {
    path: 'course-recommender-help-guide',
    component: CourseRecommenderHelpPageComponent,
    canActivate: [onAuthGuard('course-recommender')],
  },
  {
    path: 'course-grade-estimation-help-guide',
    component: CourseGradeEstimationHelpPageComponent,
    canActivate: [onAuthGuard('course-grade-estimation')],
  },
  // {
  //   path: 'financial-aid-help',
  //   component: FinancialAidHelpPageComponent,
  //   canActivate: [onAuthGuard('financial-aid-tools')],
  // },
  // {
  //   path: 'financial-aid-help-pages',
  //   component: RouterOutletPageComponent,
  //   canActivate: [onAuthGuard('financial-aid-tools')],
  //   children: [
  // {
  //   path: 'financial-aid-tool-help',
  //   component: FinancialAidToolHelpPageComponent,
  //   canActivate: [onAuthGuard('financial-aid-tools/financial-aid')],
  // },

  // Admin Support Tools Help Pages
  {
    path: 'apr-graduation-summary-help-guide',
    component: AprGraduationSummaryHelpPageComponent,
    canActivate: [onAuthGuard('apr-graduation-summary')],
  },
  {
    path: 'entry-exit-flow-help-guide',
    component: EntryExitFlowHelpPageComponent,
    canActivate: [onAuthGuard('entry-exit-flow')],
  },
  {
    path: 'ftic-course-dwf-apr-help-guide',
    component: FticCourseDwfAprHelpPageComponent,
    canActivate: [onAuthGuard('ftic-course-dwf-apr')],
  },
  {
    path: 'transfer-enrollment-trends-help-guide',
    component: TransferEnrollmentTrendsHelpPageComponent,
    canActivate: [onAuthGuard('transfer-students-trends')],
  },

  // Admin Support External Tools Help Pages
  // {
  //   path: 'apr-graduation-summary-help-guide',
  //   component: AprGraduationSummaryHelpPageComponent,
  //   canActivate: [onAuthGuard('&tabname=ftic_dashboard')],
  // },
  // {
  //   path: 'entry-exit-flow-help-guide',
  //   component: EntryExitFlowHelpPageComponent,
  //   canActivate: [onAuthGuard('&tabname=ftic_migration_flow')],
  // },
  // {
  //   path: 'ftic-course-dwf-apr-help-guide',
  //   component: FticCourseDwfAprHelpPageComponent,
  //   canActivate: [onAuthGuard('&tabname=ftic_course_dfw_apr')],
  // },

  // Admin Support External Tools Help Pages
  {
    path: 'apr-graduation-summary-external-help-guide',
    component: AprGraduationSummaryExternalHelpPageComponent,
    canActivate: [onAuthGuard('&tabname=ftic_dashboard')],
  },
  {
    path: 'entry-exit-flow-external-help-guide',
    component: EntryExitFlowExternalHelpPageComponent,
    canActivate: [onAuthGuard('&tabname=ftic_migration_flow')],
  },
  {
    path: 'ftic-course-dwf-apr-external-help-guide',
    component: FticCourseDwfAprExternalHelpPageComponent,
    canActivate: [onAuthGuard('&tabname=ftic_course_dfw_apr')],
  },
  {
    path: 'new-applicants-help-guide',
    component: NewApplicantsHelpPageComponent,
    canActivate: [onAuthGuard('&tabname=ftic_new_applicants')],
  },
  {
    path: 'three-year-graduation-rate-help-guide',
    component: ThreeYearGraduationRateHelpPageComponent,
    canActivate: [onAuthGuard('&tabname=transfer_ontime')],
  },
  {
    path: 'transfer-enrollment-trends-external-help-guide',
    component: TransferEnrollmentTrendsExternalHelpPageComponent,
    canActivate: [onAuthGuard('&tabname=transfer_dashboard')],
  },
  {
    path: 'critical-course-score-help-guide',
    component: CriticalCourseScoreHelpPageComponent,
    canActivate: [onAuthGuard('&tabname=ftic_critical_course_score')],
  },
  {
    path: 'profile',
    component: ProfilePageComponent,
    canActivate: [onAuthGuard('general')],
  },
  {
    path: 'aboutus',
    component: AboutPageComponent,
    canActivate: [onAuthGuard('general')],
  },
  { path: '**', redirectTo: 'home' }, // wildcard route for a 404 page
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
